import { Outlet } from 'react-router-dom'

import CollectionsBootstrap from 'modules/company_page/lib/SettingsCollectionsBootstrap'

const RootPage = () => {
  return (
    <CollectionsBootstrap>
      <Outlet />
    </CollectionsBootstrap>
  )
}

export default RootPage
